import { render } from "./advanced.vue?vue&type=template&id=58268af2"
import script from "./advanced.vue?vue&type=script&lang=js"
export * from "./advanced.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__